import { NavMenuWidgetComponent } from './nav-menu-widget/nav-menu-widget.component';

export * from './nav-menu-widget/nav-menu-widget.component';

export const WIDGETS = [NavMenuWidgetComponent];